export class TwitterAccount {
  objectType;
  clientId;
  description;
  id;
  name;
  appId;
  secret;
  constructor(obj?: TwitterAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/twitter-accounts/twitter-account.model.ts